/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Archival_Results_Vekn_LinkedInputs */



/**
* | output |
* | --- |
* | "This event is linked to vekn.net, which would overwrite the correction on its next sync" |
*
* @param {Err_Tournament_Archival_Results_Vekn_LinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_archival_results_vekn_linked = /** @type {((inputs?: Err_Tournament_Archival_Results_Vekn_LinkedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Archival_Results_Vekn_LinkedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet événement est lié à vekn.net, dont la prochaine synchronisation écraserait la correction")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este evento está vinculado a vekn.net, cuya próxima sincronización sobrescribiría la corrección")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este evento está vinculado ao vekn.net, cuja próxima sincronização sobrescreveria a correção")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo evento è collegato a vekn.net, la cui prossima sincronizzazione sovrascriverebbe la correzione")
	return /** @type {LocalizedString} */ ("This event is linked to vekn.net, which would overwrite the correction on its next sync")
});